// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2iF8t","row":"ProcedureTreatmentSummary_row__3zjwI"};